module.exports = __webpack_public_path__ + "static/media/020.2df6f70f.png";